import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgChefHatFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5843 5.00078C19.0307 5.04572 21 7.04288 21 9.5C21 11.4593 19.7478 13.1262 18 13.7439V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21L6 13.7439C4.25221 13.1262 3 11.4593 3 9.5C3 7.04288 4.96932 5.04572 7.41571 5.00077C8.18709 3.23446 9.94938 2 12 2C14.0506 2 15.8129 3.23446 16.5843 5.00078ZM16 20L16 17H8V20H16Z", fill: color }));
};
export default factorySvgIcon(SvgChefHatFilled);
//# sourceMappingURL=SvgChefHatFilled.js.map